import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { etudiantsApi } from '../api/etudiants.api'
import type { CreateEtudiantRequest } from '@/shared/types/etudiant'

const ETUDIANTS_KEY = ['etudiants']

export function useEtudiants() {
  return useQuery({
    queryKey: ETUDIANTS_KEY,
    queryFn: etudiantsApi.getAll,
  })
}

export function useEtudiant(id: number | undefined) {
  return useQuery({
    queryKey: [...ETUDIANTS_KEY, id],
    queryFn: () => etudiantsApi.getById(id!),
    enabled: !!id,
  })
}

export function useEtudiantByUserId(userId: number | undefined) {
  return useQuery({
    queryKey: [...ETUDIANTS_KEY, 'user', userId],
    queryFn: () => etudiantsApi.getByUserId(userId!),
    enabled: !!userId,
  })
}

export function useCreateEtudiant() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateEtudiantRequest) => etudiantsApi.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ETUDIANTS_KEY }),
  })
}

export function useUpdateEtudiant() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, formData }: { id: number; formData: FormData }) =>
      etudiantsApi.update(id, formData),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ETUDIANTS_KEY }),
  })
}

export function useDeleteEtudiant() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => etudiantsApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ETUDIANTS_KEY }),
  })
}
